import React, { useState } from "react";
import "./portfolioNew.css";
import projectsData from "../../data/projectsData";

const Portfolio = () => {
  const [items, setItem] = useState(projectsData.projects);

  const filterItem = (categoryItem) => {
    const updatedItems = projectsData.projects.filter((curElem) => {
      return curElem.category === categoryItem;
    });
    setItem(updatedItems);
  };

  return (
    <section className="work_section" id="projects">
      <h2 className="section-title">PROJECTS</h2>
      <p className="work-intro">
        Featured projects by Shantanu Basumatary across web applications and AI
        engineering, with live demos and GitHub source code.
      </p>
      <div className="work_filters">
        <span
          className="work_item"
          onClick={() => setItem(projectsData.projects)}
        >
          Everything
        </span>
        <span className="work_item" onClick={() => filterItem("Web App")}>
          Web App
        </span>
        <span className="work_item" onClick={() => filterItem("AI ML")}>
          AI / ML
        </span>
      </div>

      <div className="work_container">
        {items.map((elem) => {
          const { id, title, category, description, liveLink, github, technologies } = elem;
          return (
            <div className="work_card" key={id}>
              <span className="work_category">{category}</span>
              <h3 className="work_title">{title}</h3>
              <p className="work_description">{description}</p>
              <div className="work_techs">
                {technologies && technologies.map((tech, idx) => (
                  <span key={idx} className="work_tech-pill">
                    {tech}
                  </span>
                ))}
              </div>
              <div className="work_links">
                {liveLink && liveLink !== github && (
                  <a
                    href={liveLink}
                    className="work_link-btn live-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-globe"></i> Live Demo
                  </a>
                )}
                {github && (
                  <a
                    href={github}
                    className="work_link-btn github-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-github"></i> GitHub
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
